var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        title: _vm.title,
        "append-to-body": "",
        visible: _vm.centerDialogVisible,
        width: "20%",
        center: "",
      },
      on: {
        close: _vm.close,
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [_c("Qr", { attrs: { size: 200, text: _vm.text } })],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "p",
            { staticStyle: { "margin-bottom": "0.1rem", color: "red" } },
            [_vm._v(_vm._s(_vm.tipText))]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }